import { mapState } from 'vuex';
import _ from 'lodash';    



export default {
    name: 'wai-search',
    props: {
    },

    data : function(){

        return {
            loading : false,

            //results : {"typeahead":[{"CUIName":"Bad/foul;breath","STY":"Sign or Symptom","Popularity":4378,"CUI":"C0018520","p":0.20250995457172394},{"CUIName":"fevers","STY":"Sign or Symptom","Popularity":308565,"CUI":"C0015967","p":0.1338922679424286},{"CUIName":"weals","STY":"Sign or Symptom","Popularity":6040,"CUI":"C0221232","p":0.11236608028411865},{"CUIName":"Blush","STY":"Sign or Symptom","Popularity":3460,"CUI":"C0005874","p":0.08430758118629456},{"CUIName":"Chilling","STY":"Sign or Symptom","Popularity":19842,"CUI":"C0085593","p":0.058518365025520325},{"CUIName":"Pyotraumatic dermatitis","STY":"Disease or Syndrome","Popularity":9772,"CUI":"C0263214","p":0.04028847813606262},{"CUIName":"Trichinosis","STY":"Disease or Syndrome","Popularity":5024,"CUI":"C0040896","p":0.03693284094333649}]},
            //show : true,
            show : false,
            history : [],
            results : [],            
            resultsmap : {},
            text : '',

            processid : null
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        focus : function(){
            if(!_.isEmpty(this.results) && !this.show){
                this.show = true
            }
        },
        blur : function(){

            this.show = false    
            this.loading = false
        },
        tosearch : function(name){
            this.text = name

            this.fastsearch()
        },
        select : function(cui){

            this.loading = false
            this.results = []
            this.show = false
            this.text = ''

            this.$emit('select', this.resultsmap[cui])
            
        },
        fastsearch : _.debounce(function(){

            if(!this.text) {
                
                this.loading = false
                this.results = []
                this.show = false

                return
            }

            this.loading = true

            var  processid = this.$f.makeid()

            this.processid = processid

            this.$root.api.wai.search.incremental({

                text : this.text,
                cnt : 7

            }).then(results => {

                console.log(processid, this.processid)

                if (this.loading && processid == this.processid){
                    this.loading = false
                    this.results = results.data

                    this.resultsmap = _.keyBy(this.results, function(r) {
                        return r.CUI
                    });

                    console.log('this.resultsmap', this.resultsmap)

                    this.show = true
                }
                else{
                    
                }

                

            }).catch(error => {

                console.log(error)

                if (this.loading){
                    this.loading = false
                }
                else{

                }

                

            })

        }, 500)
    },
}